import { Team } from 'functions/src/types/firestore/Game/Tournament/Guestlist';

export type RegistrationFunctionsParams = {
  userId: string;
  id: string;
  title: string;
  gameId: string;
  foundTeam: Team;
};

export const registrationFunctions = ({
  userId,
  id,
  title,
  gameId,
  foundTeam,
}) => {
  return {
    notifyMe: async () => {
      // TODO: Replace PopUp with new Wizard Component
      // const { doc, getDoc } = await import('firebase/firestore');
      // const userDoc = await getDoc(doc(firestore, `User/${userId}`));
      // const phoneNumber = userDoc.get('hidden.phone');
      // if (!phoneNumber) {
      //   return setPopUp({
      //     open: true,
      //     variant: 'alerts',
      //   });
      // }
      const { subscribeToUpdates } = await import(
        '../../../firebaseCloud/twilio/subscribeToUpdates'
      );
      await subscribeToUpdates({
        serviceConfig: {
          name: 'tournamentAlerts',
          options: {
            tournamentId: id,
            tournamentTitle: title,
          },
        },
        userId,
      });
    },
    unsubscribe: async () => {
      if (!userId) {
        return;
      }
      const { unsubscribeFromUpdates } = await import(
        '../../../firebaseCloud/twilio/unsubscribeFromUpdate'
      );
      await unsubscribeFromUpdates({
        userId,
        serviceConfig: {
          name: 'tournamentAlerts',
          options: {
            tournamentId: id,
            tournamentTitle: title,
          },
        },
      });
    },
    setTeamName: async (newName: string, teamId: string) => {
      if (!userId || !teamId || !newName) {
        return;
      }
      const { updateTeamName } = await import(
        '../../../firebaseCloud/tournament/updateTeamName'
      );
      await updateTeamName({
        gameId,
        teamId,
        tournamentId: id,
        userId,
        newName,
      });
    },
    leaveTeam: async (teamId: string) => {
      if (!userId || !teamId) {
        return;
      }
      const { exitTeam } = await import(
        '../../../firebaseCloud/tournament/exitTeam'
      );
      await exitTeam({
        gameId,
        teamId,
        tournamentId: id,
        userId,
      });
    },
    rejectInvite: async (teamId: string, captainId: string) => {
      if (!userId) {
        return;
      }
      const { rejectInvite } = await import(
        '../../../firebaseCloud/tournament/rejectInvite'
      );
      await rejectInvite({
        gameId,
        tournamentId: id,
        rejectorId: userId,
        teamId,
        inviterId: captainId,
      });
    },
    acceptInvite: async (
      teamId: string,
      teamCaptainId: string,
      details: Record<string, unknown>,
    ) => {
      if (!userId || !teamId) {
        return;
      }
      const { acceptInvite } = await import(
        '../../../firebaseCloud/tournament/acceptInvite'
      );
      await acceptInvite({
        acceptorId: userId,
        gameId,
        tournamentId: id,
        inviterId: teamCaptainId,
        teamId,
        details,
      });
    },
    disbandTeam: async () => {
      const teamId = foundTeam?.id;
      if (!userId || !teamId) {
        return;
      }
      const leaveTeamModule = await import(
        '../../../firebaseCloud/tournament/exitTeam'
      );
      const leaveFn = leaveTeamModule.exitTeam;
      await leaveFn({
        gameId,
        teamId,
        tournamentId: id,
        userId,
      });
    },
    uninvite: async (memberToRemove: string) => {
      if (!userId || !foundTeam?.name) {
        return;
      }
      const { dropTeamMember } = await import(
        '../../../firebaseCloud/tournament/dropTeamMember'
      );
      await dropTeamMember({
        captainId: userId,
        gameId,
        tournamentId: id,
        teamId: foundTeam.id,
        removeMemberId: memberToRemove,
      });
    },
    searchUsername: async (usernameToSearch: string) => {
      const { usernameSearch } = await import(
        '../../../firebaseCloud/search/usernameSearch'
      );
      const result = await usernameSearch({
        searchQuery: usernameToSearch,
      });
      return result.data;
    },
  };
};
